import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-950 px-4 pb-24 pt-6 sm:pb-28" data-id="element-167" data-mp="19j53j40hsmi0">
      <div className="mx-auto w-full max-w-3xl border-t border-white/10 pt-6 text-center" data-id="element-168" data-mp="206j2vgr4o7dc">
        <p className="font-display text-base font-bold text-white" data-id="element-169" data-mp="2f53d7hig6pgr">
          Dra. <span className="text-navy-300" data-id="element-170" data-mp="2a5qossbxhac2">Karito</span> · Ruta
          Hipotiroidismo™
        </p>
        <p className="mx-auto mt-3 max-w-xl text-[11px] leading-relaxed text-navy-100/50 sm:text-xs" data-id="element-171" data-mp="1mg5yfodg3asr">
          Este material es de carácter educativo y no sustituye el juicio
          clínico ni las guías oficiales. © {new Date().getFullYear()} Ruta
          Hipotiroidismo™. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}